import usePriorityStates from "../hooks/usePriorityStates";

export default function StateSelect({ value, onChange, placeholder = "Select your state…", className = "", testId }) {
  const s = usePriorityStates();
  const isTop = (c) => s.high_priority.some((h) => h.code === c) || s.priority.some((p) => p.code === c);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={className} data-testid={testId} aria-label="State">
      <option value="">{placeholder}</option>
      {s.high_priority.length > 0 && (
        <optgroup label="★ Top priority — hiring fastest">
          {s.high_priority.map((x) => <option key={x.code} value={x.code}>{x.label}</option>)}
        </optgroup>
      )}
      {s.priority.length > 0 && (
        <optgroup label="Hiring actively">
          {s.priority.map((x) => <option key={x.code} value={x.code}>{x.label}</option>)}
        </optgroup>
      )}
      {s.all_states.length > 0 && (
        <optgroup label="All other states — welcome to apply">
          {s.all_states.filter((x) => !isTop(x.code)).map((x) => <option key={x.code} value={x.code}>{x.label}</option>)}
        </optgroup>
      )}
    </select>
  );
}
